export const INTRO_MESSAGE = {
    id: 1,
    content: {
        type: "text",
        message: "Hi there! Ask me a question!"
    },
    sender: "agent",
    metadata: {}
}


export const FALLBACK_ERROR_MESSAGE = "Sorry, I didn't understand that. Please try again.";

export const isAIMessage = (message) => {
    return message.sender === 'agent';
}

export const getMessageColor = (teamColors, message) => {
    if (!Object.keys(teamColors).length) return 'gray';

    return teamColors.font_colors[isAIMessage(message) ? 0 : 1];
}

export const isNotDefaultIntroMessage = (message) => message.id !== 1;

export const isFollowUpMessage = (message) => {
    return message?.event_type === "chatbot_followup"
}

export const getTableData = (apiResponse) => {
    const columnNames = apiResponse?.outbound_content?.result?.column_names || [];
    const data = apiResponse?.outbound_content?.result?.data || [];
    return [
        columnNames,
        ...data
    ]
}
